// @flow

import type { Action } from './store.type';

export const UPDATE_PERSONALIZATION_REQUEST = 'UPDATE_PERSONALIZATION_REQUEST';
type UPDATE_PERSONALIZATION_REQUEST_TYPE = 'UPDATE_PERSONALIZATION_REQUEST';

export const UPDATE_PERSONALIZATION_SUCCESS = 'UPDATE_PERSONALIZATION_SUCCESS';
type UPDATE_PERSONALIZATION_SUCCESS_TYPE = 'UPDATE_PERSONALIZATION_SUCCESS';

export const UPDATE_PERSONALIZATION_FAILURE = 'UPDATE_PERSONALIZATION_FAILURE';
type UPDATE_PERSONALIZATION_FAILURE_TYPE = 'UPDATE_PERSONALIZATION_FAILURE';

export const GET_PERSONALIZATION_REQUEST = 'GET_PERSONALIZATION_REQUEST';
type GET_PERSONALIZATION_REQUEST_TYPE = 'GET_PERSONALIZATION_REQUEST';

export const GET_PERSONALIZATION_SUCCESS = 'GET_PERSONALIZATION_SUCCESS';
type GET_PERSONALIZATION_SUCCESS_TYPE = 'GET_PERSONALIZATION_SUCCESS';

export const GET_PERSONALIZATION_FAILURE = 'GET_PERSONALIZATION_FAILURE';
type GET_PERSONALIZATION_FAILURE_TYPE = 'GET_PERSONALIZATION_FAILURE';

export const TRIGGER_SYNC_PERSONALIZATION = 'TRIGGER_SYNC_PERSONALIZATION';
export const STOP_TRIGGER_SYNC_PERSONALIZATION = 'STOP_TRIGGER_SYNC_PERSONALIZATION';

// Check live theme supported
type PersonalizationSuccess = {};
type PersonalizationFailure = {
  error: any
};
type GetPersonalizationRequestAction = Action<GET_PERSONALIZATION_REQUEST_TYPE, null>;

type GetPersonalizationSuccessAction = Action<
  GET_PERSONALIZATION_SUCCESS_TYPE,
  PersonalizationSuccess
>;

type GetPersonalizationFailureAction = Action<
  GET_PERSONALIZATION_FAILURE_TYPE,
  PersonalizationFailure
>;

type UpdatePersonalizationRequestAction = Action<UPDATE_PERSONALIZATION_REQUEST_TYPE, null>;

type UpdatePersonalizationSuccessAction = Action<
  UPDATE_PERSONALIZATION_SUCCESS_TYPE,
  PersonalizationSuccess
>;

type UpdatePersonalizationFailureAction = Action<
  UPDATE_PERSONALIZATION_FAILURE_TYPE,
  PersonalizationFailure
>;

export type PersonalizationAction =
  | GetPersonalizationRequestAction
  | GetPersonalizationSuccessAction
  | GetPersonalizationFailureAction
  | UpdatePersonalizationRequestAction
  | UpdatePersonalizationSuccessAction
  | UpdatePersonalizationFailureAction;

export type PersonalizationState = {
  loading: boolean,
  updating: boolean,
  settings: boolean,
  success: boolean,
  checkSyncPersonalization: number,
  showSyncSuccess: boolean
};
